<template>
  <el-dialog
    title="新增用户"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <el-form-item label="账号" prop="account">
        <el-input v-model.trim="dataForm.account" placeholder="账号"></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input v-model.trim="dataForm.password" type="password" placeholder="密码"></el-input>
      </el-form-item>

      <el-form-item label="真实姓名" prop="username">
        <el-input v-model.trim="dataForm.username" placeholder="真实姓名"></el-input>
      </el-form-item>

      <el-form-item label="工号" prop="emp_no">
        <el-input v-model.trim="dataForm.emp_no" placeholder="工号"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model.trim="dataForm.email" placeholder="邮箱"></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input v-model.trim="dataForm.phone" placeholder="手机号"></el-input>
      </el-form-item>

      <!-- 角色：直接加载所有可用角色 -->
      <el-form-item label="角色" prop="role_ids">
        <el-checkbox-group v-model="dataForm.role_ids">
          <el-checkbox
            v-for="role in roleList"
            :label="role.id"
            :key="role.id"
          >
            {{ role.role_name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="dataForm.gender">
          <el-radio :label="0">不显示</el-radio>
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">锁定</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注信息" prop="remark">
        <el-input type="textarea" :rows="2" v-model="dataForm.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateUser',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      roleListLoading: false,

      roleList: [], // 角色列表

      dataForm: {
        account: null,
        password: null,
        username: null,
        emp_no: null,
        email: null,
        phone: null,
        role_ids: [],     // 存角色 ID 数组
        gender: 0,    // 默认不显示
        status: 0,   // 默认正常
        remark: null,
      },
      dataRule: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        role: [
          { type: 'array', required: true, message: '请至少选择一个角色', trigger: 'change' }
        ],
        username: [
          { required: true, message: '真实姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(); // 空值不校验
              const phoneRegex = /^1[3-9]\d{9}$/;
              if (phoneRegex.test(value)) {
                callback();
              } else {
                callback(new Error('请输入正确的手机号'));
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(); // 空值，不校验，直接通过
              // 否则进行邮箱格式校验
              const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
              if (emailRegex.test(value)) {
                callback(); // 格式正确
              } else {
                callback(new Error('请输入正确的邮箱地址'));
              }
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.loadRoleList(); // 页面加载时获取角色列表
  },
  methods: {
    // 打开弹窗
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });
    },

    // 重置表单
    resetForm() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
    },
    // 加载角色列表
    loadRoleList() {
      this.roleListLoading = true;
      this.$axios
        .get('/api-30216/api/user/roles', {
          params: { userId: 0 }
        })
        .then(res => {
          console.log('角色列表:', res);
          const data = res;
          this.roleList = data; // 直接赋值，字段已匹配
          // if (data.code === 200 && Array.isArray(data.data)) {
          //   this.roleList = data.data; // 直接赋值，字段已匹配
          // } else {
          //   this.$message.error(data.message || '角色列表获取失败');
          //   this.roleList = [];
          // }
        })
        .catch(err => {
          this.$message.error('请求角色列表失败');
          console.error(err);
          this.roleList = [];
        })
        .finally(() => {
          this.roleListLoading = false;
        });
    },

    // 提交表单
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return;

        const postData = { ...this.dataForm };

        this.submitLoading = true;
        this.$axios
          .post('/api-30216/api/user', postData, {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [postData => JSON.stringify(postData)]
          })
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200) {
              this.$message.success(responseData.message || '新增成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新列表
            } else {
              this.$message.error(responseData.message || '新增失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
            } else if (err.message) {
              errorMessage = err.message;
            }
           // this.$message.error(errorMessage);
            console.error('请求错误详情:', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
</style>